import { getLabelName} from "../../../utils";
import {GatherItemModel, ItemModel} from "../../../models";
import {ButtonBox, TextBox} from "../../";
import React, {Dispatch, SetStateAction} from "react";
import {
    handleChangeItemGathersValues,
    handleDeleteItemGathersRow,
} from "../businessLogic/itemStoresBl";
import {TableColumn} from "react-data-table-component";
import {getTextBoxNumericOrDefaultValue} from "../../transactions/common/businessLogic/transactionBl";

export const handleGenerateGatheredItemsColumns = (
    setState: Dispatch<SetStateAction<ItemModel>>,isArabic:boolean
): TableColumn<GatherItemModel>[]=> {
    return [
        {
            name: isArabic ? getLabelName("NameAr") : getLabelName("NameEm"),
            cell: (row: GatherItemModel, index) => (
                <TextBox
                    labelName=""
                    isReadOnly={true}
                    inputName={isArabic?"ItemNameAr":"ItemNameEn"}
                    type="text"
                    inputValue={isArabic? row.ItemNameAr:row.ItemNameEn}
                />
            ),
        },
        {
            name: getLabelName("quantity"),
            cell: (row: GatherItemModel) => (
                <TextBox
                    labelName=""
                    type="quantity"
                    inputName="Quantity"
                    inputValue={row.Quantity}
                    onChange={(e: any) => {
                        const value: number = getTextBoxNumericOrDefaultValue(e);
                        handleChangeItemGathersValues(
                            setState,
                            row.rowKey || `${row.ID}`,
                            [{key: "Quantity", value: value}],true
                        );
                    }}
                />
            ),
            width: "10%",
        },
        {
            name: getLabelName("price"),
            cell: (row: GatherItemModel) => (
                <TextBox
                    labelName=""
                    isReadOnly={true}
                    inputName="PriceSale"
                    type="text"
                    inputValue={row.PriceSale}
                />
            ),
            width: "10%",
        },
        {
            name: getLabelName("cost"),
            cell: (row: GatherItemModel) => (
                <TextBox
                    labelName=""
                    isReadOnly={true}
                    inputName="PriceCost"
                    type="text"
                    inputValue={row.PriceCost}
                />
            ),
            width: "10%",
        },
        {
            name: getLabelName("total"),
            cell: (row: GatherItemModel) => (
                <TextBox
                    labelName=""
                    isReadOnly={true}
                    inputName="Total"
                    type="text"
                    inputValue={row.PriceSale * row.Quantity}
                />
            ),
            width: "10%",
        },
        {
            name: getLabelName("delete"),
            cell: (row: GatherItemModel) => (
                <ButtonBox  iconType="delete"
                            variant="danger"
                            className="btn btn-sm"
                            onClick={() => {
                                handleDeleteItemGathersRow(
                                    setState,
                                    row.rowKey || `${row.ID}`,
                                    row.ID ==null || row.ID==0
                                );
                            }}>
                    {/*{getLabelName("delete")}*/}
                </ButtonBox>
            ),
            width: "10%",
        },
    ];
};
